import api from "lib/api";

export const getWorkingLocationList = async (params = {}) => {
  return await api.post("/v1/workInLocation/getWorkInLocationPaging", params);
};

export const getWorkingLocation = async (params = {}) => {
  return await api.post("/v1/workInLocation/getWorkInLocation", params);
};

export const createWoringLocation = async (params = {}) => {
  return await api.post("/v1/workInLocation/createWorkInLocation", params);
};

export const editWorkingLocation = async (params = {}) => {
  return await api.post("/v1/workInLocation/updateWorkInLocation", params);
};

export const deleteWorkingLocation = async (params = {}) => {
  return await api.post(
    "/v1/workInLocation/manageStatusWorkInLocation",
    params
  );
};

export const dropdownWorkInLocationForOffsite = async (params = {}) => {
  return await api.post(
    "/v1/workInLocation/dropdownWorkInLocationForOffsite",
    params
  );
};
